import { ModalStatus } from "@/constants/modal";
import { ICashFloat } from "@/interfaces/cash-float/cash-float";
import { IBookingCustomerInfo } from "@/types/db/product-slot-booking";
import { GroupInfo } from "@/types/gql/group";
import { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from "axios";

// let authHeaderCallback:  = null;
// let gqlAuthHeader:  = null;

export const SharedCallbacks: {
  authHeaderCallback:
    | null
    | ((
        conf: InternalAxiosRequestConfig
      ) => Promise<InternalAxiosRequestConfig>);
  gqlAuthHeader: null | (() => Promise<string>);
  getSellerId: null | (() => number);
  getPOSConfigId: null | (() => number);
  getGroupInfo: null | (() => GroupInfo);
  UserLogOut: null | ((data?: { signWorkOutEvent: boolean }) => string);
  ModalSetStatus: null | ((status: ModalStatus) => void);
  cashfloat: null | (() => ICashFloat | null);
  setCustomerInfo: null | ((customerInfo: IBookingCustomerInfo) => void);
  getSelectedCustomerId: null | (() => number | null);
  getSelectedCustomerEmail: null | (() => string);
  getSelectedCustomerLastName: null | (() => string);
  getSelectedCustomerFirstName: null | (() => string);
  monitorLatencyCallback:
    | null
    | ((response: AxiosResponse, error?: AxiosError) => void);
  startTimeMetadataCallback:
    | null
    | ((conf: InternalAxiosRequestConfig) => void);
} = {
  authHeaderCallback: null,
  gqlAuthHeader: null,
  getSellerId: null,
  getPOSConfigId: null,
  getGroupInfo: null,
  UserLogOut: null,
  ModalSetStatus: null,
  cashfloat: null,
  setCustomerInfo: null,
  getSelectedCustomerId: null,
  getSelectedCustomerEmail: null,
  getSelectedCustomerLastName: null,
  getSelectedCustomerFirstName: null,
  monitorLatencyCallback: null,
  startTimeMetadataCallback: null,
};
